import * as apiGetSettingKey from 'api/setting/GetSettingV1';
import { ReducerBuilder } from 'reducers/ReducerBuilder';
import { payloadReducer } from 'reducers/reducerUtils';

export type MenuBarOrder = string[];

export const defaultMenuBarOrder: string[] = [
	'Recipe',
	'Menu',
	'MenuPlan',
	'Ingredient',
	'BaseIngredient',
	'Accessory',
	'MasterData',
	'Admin',
];

export async function getMenuBarOrder(): Promise<MenuBarOrder> {
	const response = await apiGetSettingKey.callApi();
	return response.map((x) => x.ui.menuBarOrder.split(',')).getOrDefault([]);
}

const rb = new ReducerBuilder<MenuBarOrder>();
export const MenuBarOrderLoadedAction = rb.createActionForReducer(
	payloadReducer((x) => x),
	'MenuBarOrder/LoadedFromBackend'
);

export const menuBarOrderReducer = rb.createReducer();
